// === wizardStepType.js START ====================================================================

wizardSteps["textTemplates"] = {
    templateName: "#wizardStepTextTemplates",
    newTemplateText: '',
    onInit: function() {
        Handlebars.registerPartial('textTemplatesList', $('#wizardStepTextTemplates__templateList').html());
    },
    beforeRender: function (ctx) {
        // This function is called before rendering is done.
        // Model preparation and stuff can be done here.

        ctx.model = {
            templates: []
        };
    },
    afterRender: function (ctx) {
        var newTemplateText = ctx.$el.find('.m-modal__text-templates__edit-frame__templateName').text().trim();
        wizardSteps["textTemplates"]['newTemplateText'] = newTemplateText;

        // Events are bound here
        ApiClient.getTextTemplates()
            .done(function(data) {
                ctx.model.templates = data.data;
                wizardSteps["textTemplates"].rebuildTextTemplatesList(ctx);

                // Resize the iframe and reposition the modal.
                window.performResize();
                window.PositionModal();
            })
            .fail(function(result) {
                var showData = 'An unknown error occured while loading the text templates.';
                if (result.responseJSON) {
                    if (result.responseJSON.error && result.responseJSON.error.message) {
                        showData = result.responseJSON.error.message;
                    } else if (result.responseJSON.data) {
                        showData = result.responseJSON.data;
                    }
                }
                ShowErrorPanel(showData);
            });

        ctx.$el.find('#m-modal__text-templates__button--new')
            .attr('disabled', 'disabled')
            .on('click',
                function() {
                    var $this = $(this);
                    $this.attr('disabled', 'disabled');
                    wizardSteps["textTemplates"].resetEditFrame(ctx);
                });

        ctx.$el.find('#m-modal__text-templates__button--persist')
            .on('click',
                function() {
                    var $editFrame = ctx.$el.find('.m-modal__text-templates__edit-frame');
                    var id = $editFrame.attr('data-templateId');
                    var name = $editFrame.find('#m-modal__text-templates__input--name').val().trim();
                    var desc = $editFrame.find('#m-modal__text-templates__input--description').val().trim();

                    var template = {
                        templateName: name,
                        templateContent: desc
                    };

                    var promise;
                    if (id && id !== '') {
                        template.id = id;
                        promise = ApiClient.updateTextTemplate(template.id, template);
                    } else {
                        promise = ApiClient.createTextTemplate(template);
                    }

                    promise.done(function() {
                            ctx.$el.find('#m-modal__text-templates__button--new')
                                .attr('disabled', 'disabled');
                            wizardSteps["textTemplates"].resetEditFrame(ctx);
                            ApiClient.getTextTemplates()
                                .then(function(data) {
                                    ctx.model.templates = data.data;
                                    wizardSteps["textTemplates"].rebuildTextTemplatesList(ctx);

                                    // Resize the iframe and reposition the modal.
                                    window.performResize();
                                    window.PositionModal();
                                });
                        })
                        .fail(function(result) {
                            var showData = 'An unknown error occured while submitting the text template.';
                            if (result.responseJSON) {
                                if (result.responseJSON.error && result.responseJSON.error.message) {
                                    showData = result.responseJSON.error.message;
                                } else if (result.responseJSON.data) {
                                    showData = result.responseJSON.data;
                                }
                            }
                            ShowErrorPanel(showData);
                        });
                });
    },
    resetEditFrame: function(ctx) {
        var $editFrame = ctx.$el.find('.m-modal__text-templates__edit-frame');

        $editFrame.attr('data-templateId', '');
        $editFrame.find('.m-modal__text-templates__edit-frame__templateName').text(wizardSteps["textTemplates"]['newTemplateText']);
        $editFrame.find('#m-modal__text-templates__input--name').val('');
        $editFrame.find('#m-modal__text-templates__input--description').val('');
    },
    getButtonList: function () {
        return {};
    },
    rebuildTextTemplatesList: function(ctx) {
        var template = Handlebars.partials['textTemplatesList'];
        var $wrapper = ctx.$el.find('.m-modal__text-templates__list');
        $wrapper.html(template(ctx.model));

        $wrapper.find('.m-modal__text-templates__icon--edit')
            .on('click',
                function() {
                    var $this = $(this);
                    var $parent = $this.parents('.m-modal__text-templates__list__item').first();
                    var index = $parent.attr('data-index');
                    var template = ctx.model.templates[index];

                    ctx.$el.find('#m-modal__text-templates__button--new')
                        .removeAttr('disabled');

                    var $editFrame = ctx.$el.find('.m-modal__text-templates__edit-frame');

                    $editFrame.attr('data-templateId', template.id);
                    $editFrame.find('.m-modal__text-templates__edit-frame__templateName').text(template.templateName);
                    $editFrame.find('#m-modal__text-templates__input--name').val(template.templateName);
                    $editFrame.find('#m-modal__text-templates__input--description').val(template.templateContent);
                });

        $wrapper.find('.m-modal__text-templates__icon--remove')
            .on('click',
                function() {
                    var $this = $(this);
                    var $parent = $this.parents('.m-modal__text-templates__list__item').first();
                    var index = $parent.attr('data-index');
                    var template = ctx.model.templates[index];

                    Modal.show({
                        title: $t('Textvorlage löschen'),
                        content: '<p>' +
                            $t('Sie sind dabei die Textvorlage mit dem Titel "{0}" zu löschen. Bitte bestätigen Sie Ihre Aktion.').format(template.templateName) +
                            '</p>',
                        actions: [
                            {
                                title: $t('Abbrechen'),
                                icon: 'icon-cancel',
                                onClick: function() {
                                    Modal.hide();
                                }
                            }, {
                                title: $t('OK'),
                                icon: 'icon-check',
                                onClick: function() {
                                    ApiClient.deleteTextTemplate(template.id)
                                        .done(function() {
                                            ctx.model.templates.splice(index, 1);
                                            wizardSteps["textTemplates"].rebuildTextTemplatesList(ctx);

                                            var $editFrame = ctx.$el.find('.m-modal__text-templates__edit-frame');
                                            if ($editFrame.attr('data-templateId') === template.id) {
                                                wizardSteps["textTemplates"].resetEditFrame(ctx);
                                            }
                                        })
                                        .fail(function(result) {
                                            var showData = 'An unknown error occured while deleting the text template.';
                                            if (result.responseJSON) {
                                                if (result.responseJSON.error && result.responseJSON.error.message) {
                                                    showData = result.responseJSON.error.message;
                                                } else if (result.responseJSON.data) {
                                                    showData = result.responseJSON.data;
                                                }
                                            }
                                            ShowErrorPanel(showData);
                                        });
                                }
                            }
                        ]
                    });
                });
    }
};

// === wizardStepType.js START ====================================================================
